var React = require('react');

function IOS (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.1588 15.133C35.5544 14.9429 38.4142 17.4034 41.2638 17.4034C44.1134 17.4034 46.8114 14.9429 51.3688 15.133C53.5416 15.104 55.6945 15.5465 57.676 16.4295C59.6575 17.3125 61.4194 18.6145 62.8379 20.244C60.5667 21.3231 58.6474 23.0118 57.2985 25.1179C55.9497 27.224 55.2255 29.6628 55.2087 32.1563C55.2284 34.8273 56.0845 37.4265 57.659 39.5958C59.2335 41.7651 61.4489 43.3977 64 44.2687C61.8982 50.3199 58.4423 56.011 53.6727 59.0116C47.5592 62.2323 43.9315 56.5511 41.2537 56.5511C38.3838 56.5511 34.9481 62.2323 28.8346 59.0116C21.5691 54.4807 17.1735 44.0787 16.2135 35.377C14.4956 20.434 23.479 15.133 31.1588 15.133ZM40.516 14.1928C40.2533 5.30104 45.0734 1.13022 53.2988 0C51.7629 9.6519 47.9432 12.6725 40.4857 14.1928H40.516Z","fill":"currentColor"}));
}

IOS.defaultProps = {"width":"80","height":"60","viewBox":"0 0 80 60","fill":"none"};

module.exports = IOS;

IOS.default = IOS;
